/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdInputProps } from './type';

export const inputDefaultProps: TdInputProps = {
  align: 'left',
  allowInputOverMax: false,
  autocomplete: undefined,
  autofocus: false,
  borderless: false,
  clearTrigger: 'always',
  clearable: false,
  cursorColor: '#0052d9',
  disabled: undefined,
  layout: 'horizontal',
  placeholder: undefined,
  readonly: undefined,
  spellcheck: false,
  status: 'default',
  type: 'text',
};
